import axios from "axios";

export function fetchSettings(accountId, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/settings`
  };
  return axios(config);
}

export function fetchRecord(accountId, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/record`
  };
  return axios(config);
}

export function fetchRecordResourceCode(accountId, resource, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/record-resource?resourceCode=${resource}`
  };
  return axios(config);
}

export function fetchRecordAction(accountId, action, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/record-action?action=${action}`
  };
  return axios(config);
}

export function fetchContract(accountId, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/contract`
  };
  return axios(config);
}

export function fetchOrderLimits(accountId, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/order-limits`
  };
  return axios(config);
}

export function fetchAccountSso(accountId, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/account-sso`
  };
  return axios(config);
}

export function fetchLargeOrder(accountId, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/large-order`
  };
  return axios(config);
}

export function fetchShopInfoByAccountId(id, type, querystring) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${id}/info`,
    params: querystring
  };
  return axios(config);
}

export function fetchPrintersUnderShop(accountId, shop, type) {
  let config = {
      method: 'GET',
      url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/printers`,
      params: shop
  }
  return axios(config);
}

export function getInvoiceSetting(accountId, type) {
  let config = {
      method: 'GET',
      url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/invoice`
  }
  return axios(config);
}

export function fetchMWActive(accountId, type) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/mw-settings-active`
  }
  return axios(config);
}

export function fetchSubscribers(accountId, type, subscribeType) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/${type}/air3/${accountId}/types/${subscribeType}/subscribers`
  }
  return axios(config);
}